import './range.datepicker.scss'

import $ from 'jquery'
import 'moment/locale/ru'
import moment from 'moment'
import 'imports-loader?define=>false!daterangepicker' // eslint-disable-line import/no-webpack-loader-syntax

export default class SingleDatePicker {
  constructor(input, onChangeCallback) {
    this.input = input
    this.onChangeCallback = onChangeCallback
    if (!onChangeCallback) {
      this.onChangeCallback = function() {}
    }
  }

  wrap() {
    this.input.wrap($('<div/>').css({ whiteSpace: 'nowrap' }))
    this.input.daterangepicker({
      singleDatePicker: true,
      minDate: this.input.data('min-date'),
      autoUpdateInput: false,
      locale: {
        format: 'DD.MM.YYYY',
        language: 'ru',
        monthNames: moment.months()
      }
    })

    this.clearButton = this.makeClearButton(this.input.data('clear-button-text') || '')
    this.hint = this.makeEmptyValueHint(this.input.data('empty-value-text') || '')

    this.clearButton.insertAfter(this.input)
    this.hint.insertAfter(this.input)

    this.clearButton.click((e) => {
      this.input.val('')
      this.onChangeCallback('')
      this.hideClearButton()
      this.showHint()
      e.stopPropagation()
    })

    if (this.input.val()) {
      this.showClearButton()
      this.hideHint()
    } else {
      this.hideClearButton()
      this.showHint()
    }

    this.input.on('apply.daterangepicker', (ev, picker) => {
      const formattedDate = picker.startDate.format(picker.locale.format)
      $(ev.target).val(formattedDate)
      this.onChangeCallback(formattedDate)
      this.showClearButton()
      this.hideHint()
    })
  }

  makeClearButton(title) {
    return $('<a/>', { href: 'javascript:void(0);' }).text(title)
  }

  makeEmptyValueHint(title) {
    return $('<span/>')
      .css({ color: 'grey', fontSize: '12px' })
      .text(title)
  }

  showClearButton() {
    this.clearButton.css({ display: 'initial' })
  }

  hideClearButton() {
    this.clearButton.css({ display: 'none' })
  }

  showHint() {
    this.hint.css({ display: 'initial' })
  }

  hideHint() {
    this.hint.css({ display: 'none' })
  }
}
